import {
  NEWLINE,
  RECONTRACT,
  RRP_EQUIPMENT,
  RRP_ACCESSORY,
  CHECK_ELIGIBILITY,
  ELIGIBLIE_NUMBERS_DETAILS,
  RESERVE_NUMBER,
  CATALOGUE,
  BUY_ADD_ONS,
  TERMINATE_NUMBER,
  CEASE_ADDONS,
  REPLACE_SIM,
  ACTIVATE_SIM,
  CHANGE_MOBILE_NUMBER,
  NUMBER_PORT
} from '@/config/common';

export const urlConfig = {
  'new-line': {
    pathname: '/order/priceplan',
    ordertype: NEWLINE
  },
  'rrp-devices': {
    pathname: '/order/equipment',
    ordertype: RRP_EQUIPMENT
  },
  'rrp-accessories': {
    pathname: '/order/equipment',
    ordertype: RRP_ACCESSORY
  },
  'add-ons': {
    pathname: '/buyaddons',
    ordertype: BUY_ADD_ONS
  },
  're-contract': {
    pathname: '/order/contract',
    ordertype: RECONTRACT
  },
  'reserve-number': {
    pathname: '/reservenumber',
    ordertype: RESERVE_NUMBER
  },
  'cease-addons': {
    pathname: '/ceaseaddons',
    ordertype: CEASE_ADDONS
  },
  'activate-sim': {
    pathname: '/simactivation',
    ordertype: ACTIVATE_SIM
  },
  'catalogue': {
    pathname: '/catalogue',
    ordertype: CATALOGUE
  },
  'terminate-number': {
    pathname: '/terminatenumber',
    ordertype: TERMINATE_NUMBER
  },
  'managed-services': {
    pathname: '/#',
    ordertype: ''
  },
  'check-eligibility': {
    pathname: '/checkeligibility',
    ordertype: CHECK_ELIGIBILITY
  },
  'eligible-numbers-details': {
    pathname: '/checkeligibility/eligiblenumbersdetails',
    ordertype: ELIGIBLIE_NUMBERS_DETAILS
  },
  'replace-sim': {
    pathname: '/replacesim',
    ordertype: REPLACE_SIM
  },
  'change-mobileno': {
    pathname: '/changemobilenumber',
    ordertype: CHANGE_MOBILE_NUMBER
  },
  'number-port': {
    pathname: '/numberport',
    ordertype: NUMBER_PORT
  },
};
